<template>
  <div class="tl-form" v-loading="uploadLoading">
    <el-upload
      list-type="picture-card"
      :on-remove="handleRemoveFile(2)"
      :http-request="handleUploads(2)"
      :on-change="handleChange(2)"
      action="#"
      accept="image/*"
      :file-list="form.photoFile"
    >
      <div class="add">+</div>

      <!-- <template #file="{ file }">
              <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
            </template> -->
    </el-upload>
  </div>
</template>

<script setup lang="ts">
import { ref, VNodeRef as vRef } from 'vue';
import { ElMessage } from 'element-plus';
import { ossUpload } from '@dts/shared/src/utils/alioss';
import { ICommunityProfileData, ResourceEnum, FilesType } from './types';
import { UploadRequestOptions, UploadUserFile } from 'element-plus/es/components/upload/src/upload';

interface Props {
  form: ICommunityProfileData;
  VNodeRef?: vRef;
}

const props = withDefaults(defineProps<Props>(), {
  form: () => ({}),
});

const formRef = ref();
const emits = defineEmits(['emitImg']);
const uploadLoading = ref(false);

const filesMapping = {
  [ResourceEnum.IMAGE]: 'photoFile',
  [ResourceEnum.NAME_LIST]: 'urlFile',
};

const handleChange = (type: ResourceEnum) => (_: any, uploadFiles: UploadUserFile[]) => {
  // return;
  const idx = filesMapping[type] as keyof FilesType;

  props.form[idx] = uploadFiles.filter((item) => item.size);
};
const handleUploads = (type: ResourceEnum) => async (f: UploadRequestOptions) => {
  console.log(f);
  const { file } = f;
  const idx = filesMapping[type] as keyof FilesType;

  if (!props.form[idx]) {
    props.form[idx] = [];
  }
  const size = file.size / 1024 / 1024;
  if (size > 10) {
    ElMessage.error('File Limited 10MB');
    return;
  }

  uploadLoading.value = true;

  const extra =
    type === ResourceEnum.NAME_LIST
      ? {
          headers: {
            'Content-Type': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          },
        }
      : {};

  ossUpload(file, 'feedback', extra)
    .then((res) => {
      // props.form[idx]?.push({
      //   ...
      // })
      const target = props.form[idx]?.find((item) => item.name === file.name);
      if (target) {
        target.key = res.filePath;
        target.originName = decodeURIComponent(res.fileName || '');
      }
    })
    .catch((e) => {
      console.error('upload err: ', e);
    })
    .finally(() => {
      emits('emitImg', props.form.photoFile);
      uploadLoading.value = false;
    });
  // .finally(() => {
  //   emits('emitImg', props.form.photoFile);
  //   uploadLoading.value = false;
  // });
};

const handleRemoveFile = (type: ResourceEnum) => (uploadFile: UploadUserFile) => {
  const idx = filesMapping[type] as keyof FilesType;
  if (!props.form[idx]) {
    props.form[idx] = [];
  }
  props.form[idx] = (props.form[idx] || [])?.filter((item) => item.name !== uploadFile.name);
  emits('emitImg', props.form.photoFile);
};

const validate = async (cb: any) => {
  if (formRef.value.validate) {
    await formRef.value.validate(cb);
  }
};

const resetFields = () => {
  formRef.value.resetFields && formRef.value.resetFields();
};

defineExpose({
  validate,
  resetFields,
});
</script>

<style lang="scss" scoped>
.tl-form {
  padding: 0 20px;
  width: 70%;

  .code-input {
    width: 120px;
    margin-right: 8px;
  }

  .role-box {
    display: flex;
    align-items: center;

    &-select {
      margin-left: 12px;
    }
  }
}
.add {
  font-weight: 700;
  font-size: 30px;
}
</style>
<style lang="scss">
.tl-form {
  .el-upload-list__item {
    width: 80%;
  }
}
</style>
